import { render } from "./ViewSelect.vue?vue&type=template&id=190cef2a&scoped=true"
import script from "./ViewSelect.vue?vue&type=script&lang=js"
export * from "./ViewSelect.vue?vue&type=script&lang=js"

import "./ViewSelect.vue?vue&type=style&index=0&id=190cef2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190cef2a"]])

export default __exports__